<template>
  <!-- 视频说法 -->
  <div id="videoclaim">

    <section class="w_10f8"> <vidclbanner /> </section>

    <section> <vidclawtvid /> </section>

    <section class="w_10f8"> <vidclcont /> </section>
    

  </div>
</template>

<script>

import vidclbanner from './child/vidclbanner'//视频说法轮播及菜单
import vidclawtvid from './child/vidclawtvid'
import vidclcont from './child/vidclcont'//中间快捷菜单



export default {
  name: "videoclaim",
  components: {

    // 页面内
    vidclbanner,
    vidclawtvid,
    vidclcont,

  },
};
</script>

<style lang="scss" scoped>
#videoclaim {
  background-color: #fff;
  .w_10f8{
      width: 100%;
      background-color:#F8F8F8 ;
  }
}
</style>
